import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#696969",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": ".75",
      d: "M8.5 10.25h-5C2 10.25 1 9.5 1 7.75v-3.5c0-1.75 1-2.5 2.5-2.5h5c1.5 0 2.5.75 2.5 2.5v3.5c0 1.75-1 2.5-2.5 2.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#696969",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": ".75",
      d: "M8.5 4.5 6.935 5.75c-.515.41-1.36.41-1.875 0L3.5 4.5"
    }, null, -1)
  ]))]))
}
export default { render: render }